var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.echartData.noData == false?'chart-plate':''},[_c('div',{staticStyle:{"width":"100%","height":"calc(( 100vh - 65px ) / 2 - 40px)","margin-bottom":"60px"},attrs:{"id":_vm.id}})])}
var staticRenderFns = []

export { render, staticRenderFns }